import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { yellowMain } from '../../../constants/color';
export const QCheckbox = ({ label, checked, onChange, checkboxProps, typographyProps, mt = 0, errormsg }) => {
    const handleChange = (event) => {
        onChange(event.target.checked); // Update parent component with checked state
    };
    return (_jsxs(Box, { display: 'flex', mt: mt, alignItems: 'center', position: 'relative', gap: 1, children: [_jsx(Checkbox, { ...checkboxProps, checked: checked, onChange: handleChange, disabled: checkboxProps?.disabled, sx: {
                    color: checkboxProps?.color || yellowMain,
                    cursor: 'pointer'
                } }), _jsx(Typography, { variant: 'subtitle2', color: typographyProps?.color || '#555555', ...typographyProps, onClick: () => !checkboxProps?.disabled && onChange(!checked), sx: {
                    cursor: checkboxProps?.disabled ? 'default' : 'pointer',
                    display: 'block',
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    maxWidth: '100%' // Optional: Restrict width for better readability
                }, children: label }), errormsg && (_jsx(Box, { sx: { position: 'absolute', bottom: -9, left: 5 }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, ml: 1, color: '#FF0000', children: errormsg }) }))] }));
};
